import { URLSearchParams } from '@angular/http';
import { AuditFilter } from 'app/entities/audit/audit-filter.model';
import { Observable } from 'rxjs/Observable';
import { Injectable, EventEmitter } from '@angular/core';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';
/**
 * Service for entity audit tab.
 */
@Injectable()
export class EntityAuditService {
    updateAuditInformation: EventEmitter<string> = new EventEmitter();
    filterAuditInformation: EventEmitter<AuditFilter> = new EventEmitter();
    constructor(private requestService: ObservableRequestService) { }

    addJournalEntry(description, entityId: number): Observable<any> {
        const auditUrl = ConstantsService.AUDIT + '/' + entityId;
        return this.requestService.postRequest(auditUrl,
            this.requestService.serialize({ journalentry: description }),
            this.requestService.getFormEncodedContentType());
    };

    getAuditTimeline(entityId: number, auditFilters: AuditFilter, offset: number, limit: number) {
        const auditUrl = ConstantsService.AUDIT + '/' + entityId + '/timeline';
        const params = this.buildTimelineParams(auditFilters, offset, limit);
        return this.requestService.getRequest(auditUrl, params);
    }

    getAuditDetails(entityId: number, auditFilters: AuditFilter, offset: number, limit: number) {
        return this.getAuditTimeline(entityId, auditFilters, offset, limit);
    }

    setAuditInformation(event) {
        this.updateAuditInformation.emit(event);
    }

    setFilters(event) {
        this.filterAuditInformation.emit(event);
    }

    private buildTimelineParams(auditFilters: AuditFilter, offset: number, limit: number): URLSearchParams {
        const params = new URLSearchParams();
        if (auditFilters && auditFilters.userId) {
            params.set('userId', auditFilters.userId.toString());
        }
        if (auditFilters && auditFilters.workflowType) {
            params.set('workflowType', auditFilters.workflowType);
        }
        if (auditFilters && auditFilters.startDate) {
            params.set('startDate', this.formatDateParam(auditFilters.startDate));
        }
        if (auditFilters && auditFilters.endDate) {
            params.set('endDate', this.formatDateParam(auditFilters.endDate));
        }
        if (auditFilters && auditFilters.searchText) {
            params.set('search', auditFilters.searchText.trim());
        }
        if (auditFilters && auditFilters.eventTypes && auditFilters.eventTypes.length) {
            params.set('eventTypes', auditFilters.eventTypes.join(','));
        }
        if (auditFilters && auditFilters.sortOrder) {
            params.set('sortOrder', auditFilters.sortOrder);
        }
        params.set('offset', offset.toString());
        params.set('limit', limit.toString());
        return params;
    }

    private formatDateParam(date: Date | string): string {
        if (!date) {
            return null;
        }
        if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }
        const parsed = typeof date === 'string' ? new Date(date) : date;
        const year = parsed.getFullYear();
        const month = ('0' + (parsed.getMonth() + 1)).slice(-2);
        const day = ('0' + parsed.getDate()).slice(-2);
        return year + '-' + month + '-' + day;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/audit/entity-audit.service.ts